import { Pipe, PipeTransform } from '@angular/core';
import { VkmAnswer } from 'src/app/classes/vkm-answer';

@Pipe({
    name: 'vkmAnswer',
    standalone: false,
})
export class VkmAnswerPipe implements PipeTransform {
    transform(checklistAnswers: VkmAnswer[], type: string, questionId?: number, isComment = false): string {
        if (!checklistAnswers) return '';
        if (isComment) {
            const answer = checklistAnswers.find(a => a.type === type && a.comment);
            return answer ? answer.comment : '';
        } else {
            const answer = checklistAnswers.find(a => a.type === type && a.vkm_question_id === questionId);
            return answer ? answer.answer : '';
        }
    }
}
